import { API_URL as baseApiUrl } from "@/config/env";

export const chatbotUrls = {
    startConversation: baseApiUrl + "genie/startconversationasync",
    continueChat: baseApiUrl + "genie/continuechat",
    conversationHistory: baseApiUrl + "genie/conversationhistory",
    followupQuestions: baseApiUrl + "genie/getfollowupquestions",
    dashboardCards: baseApiUrl + "genie/getdashboardcards",
    mostAskedQuestions: baseApiUrl + "genie/getmostaskedquestions",
    frequentlyAskedQuestions: baseApiUrl + "genie/GetFrequentlyAskedQuestions",
    getUserChatBotHistory: baseApiUrl + "genie/GetUserChatBotHistory",
    downloadSource: baseApiUrl + "genie/DownloadSource",
};

// Helper function to prepare chat history data
export function prepareChatHistoryData(chatHistoryData) {
    if (chatHistoryData && Array.isArray(chatHistoryData)) {
        const formattedHistory = chatHistoryData.map((item, index) => {
            return {
                id: item.conversationId || `chat-${index}`,
                title: item.title || item.firstQuestion || 'New Chat',
                timestamp: item.timestamp ? new Date(item.timestamp) : new Date(),
                conversationId: item.conversationId,
            };
        });
        return formattedHistory;
    }
    return [];
}

// Helper function to format message response
export function formatMessageResponse(responseData) {
    if (!responseData) return null;
    
    return {
        description: responseData.description || '',
        results: responseData.results || [],
        totalAttachments: responseData.totalAttachments || 0,
        conversationId: responseData.conversationId || null,
    };
}

